import type { WidgetId } from '../../content/types';
import { BangLevels, BlockDiagram, IntegralArea, MetricDefinitions, NotationPrimer } from './StaticWidgets';
import { DampingCalculator, DerivativeRate, EulerStep, ForceBalance, MatrixRows } from './MathWidgets';

export function Widget({ id }: { id: WidgetId }) {
  switch (id) {
    case 'notation-primer':
      return <NotationPrimer />;
    case 'derivative-rate':
      return <DerivativeRate />;
    case 'force-balance':
      return <ForceBalance />;
    case 'euler-step':
      return <EulerStep />;
    case 'matrix-rows':
      return <MatrixRows />;
    case 'block-diagram':
      return <BlockDiagram />;
    case 'integral-area':
      return <IntegralArea />;
    case 'bang-levels':
      return <BangLevels />;
    case 'damping-calculator':
      return <DampingCalculator />;
    case 'metric-definitions':
      return <MetricDefinitions />;
  }
}
